/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Greenfield Recorder',
    SITE_DESCRIPTION:
      'Search jobs in Greenfield, MA and find local employment opportunities with The Recorder. Your best source for Greenfield, MA local employers.',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    ASSETS: {
      logo: '/static/gr/logo.png',
      faviconsPath: '/static/gr',
    },
    OG_IMAGE: '/static/gr/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#121212',
      },
    },
    LINKEDIN_OAUTH_FEATURE_ACTIVE: false,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: false,
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-04SBN34ERZ', 'G-ZVTBLEK1KY'],
  },
});
